// extracted by mini-css-extract-plugin
export default {"thead":"UiTable_thead_EeHmA","tbody":"UiTable_tbody_JI2co"};